import React, { memo } from 'react';
// styles
import styles from '../Location.module.scss';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// widgets
import { Chip } from '@/widgets/Chip';
import Nudge from '@/pages/instamart/campaign/create/widgets/Nudge';
// components
import CitySearch from '@/components/CitySearch';
// hooks
import useNudge from '@/hooks/useNudge';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
import { Phrases } from '@/pages/instamart/campaign/create/widgets/Nudge/constants';
import { CampaignWriteModeEnum } from '@/stores/WriteCampaign/constants';
function SelectCity({ cityOptions, selectedOptions, setSelectedOptions, disabled, errorText, mode, }) {
    const { isCityNudgeVisible } = useNudge(mode === CampaignWriteModeEnum.EDIT);
    return (React.createElement("div", { className: styles.selectedPref },
        React.createElement("div", { className: styles.selectedPrefOptions },
            React.createElement(Text, { variant: DlsFontVariants.body_B1_Reg, color: DlsColorTokens.text_Med_Emphasis, className: styles.selectedPrefOptionsText }, "You can search for cities on the right. Your selected cities would reflect below."),
            React.createElement("div", null, selectedOptions.map((option) => {
                const selectedOption = cityOptions.find((item) => item.id === option);
                const handleActionButtonClick = () => setSelectedOptions(selectedOptions.filter((item) => item !== option));
                return (React.createElement(Chip, { key: option, containerClass: styles.selectedPrefOption, label: selectedOption.label, onActionButtonClick: handleActionButtonClick, disabled: disabled }));
            }))),
        React.createElement("div", null,
            React.createElement(CitySearch, { cityOptions: cityOptions, selectedOptions: selectedOptions, setSelectedOptions: setSelectedOptions, disabled: disabled, errorText: errorText }),
            isCityNudgeVisible && React.createElement(Nudge, { text: Phrases.MIN_CITIES }))));
}
export default memo(SelectCity);
